import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream font-sans text-warm-dark selection:bg-terracotta/30 selection:text-navy" data-id="element-256">
      <HeroSection data-id="element-257" />
      <PainSection data-id="element-258" />
      <RevelationSection data-id="element-259" />
      <ValueStack data-id="element-260" />
      <FAQSection data-id="element-261" />
      <GuaranteeSection data-id="element-262" />
      <FinalCTA data-id="element-263" />

      <Footer data-id="element-264" />
    </main>;
}